var _path, _line, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M.579,127.126H7L32.96,103.281h68.526c3.924,14.79-13.585,23.241-13.585,23.241h18.415l56.753-32.6s13.585-8.451,28.075,7.245l-57.659,41.05-96.6,36.523-36-.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 51.676,
    y1: 126.522,
    x2: 91.622,
    y2: 126.522
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stroke-color-main",
    cx: 121.985,
    cy: 89.667,
    r: 18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "stroke-color-main",
    cx: 67.152,
    cy: 74.334,
    r: 18
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "stroke-color-main",
    cx: 108.235,
    cy: 39.25,
    r: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.14497ee13b716b6a5dca061ccbae1d8c.svg";
export { ForwardRef as ReactComponent };